module.exports = __webpack_public_path__ + "media/application/images/banner-cb8cef93c42447048b00dd6d1327bfff.svg";